import { useEffect, useState } from 'react';
import useHttp from '../../../../../hooks/use-http';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import TabsProvider from './components/TabsProvider';
import { urls } from './api/urls';

const Testiranje = ({ idMasine, idMasineTest }) => {
  const { getData: getPregled, isLoading: pregledLoading } = useHttp('');
  const { getData: getKonverzacije, isLoading: konverzacijeLoading } =
    useHttp('');
  const [pregledTestiranja, setPregledTestiranja] = useState([]);
  const [konverzacijeTestiranja, setKonverzacijeTestiranja] = useState([]);
  const [openDialogNapomena, setOpenDialogNapomena] = useState(false);
  const [napomena, setNapomena] = useState({});

  const handleGetPregled = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_PREGLED_TESTIRANJA,
      data: { idMasine },
    };
    const result = await getPregled(config);
    setPregledTestiranja(Array.isArray(result) ? result : []);
  };

  const handleGetKonverzacije = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_KONVERZACIJE_TESTIRANJA,
      data: { idMasine: idMasineTest },
    };
    const result = await getKonverzacije(config);
    setKonverzacijeTestiranja(Array.isArray(result) ? result : []);
  };

  useEffect(() => {
    if (!idMasine && !idMasineTest) return;
    if (idMasine) handleGetPregled();
    if (idMasineTest) handleGetKonverzacije();
  }, [idMasine, idMasineTest]);

  const handleClickNapomena = (item) => {
    setOpenDialogNapomena(true);
    setNapomena(item);
  };

  return (
    <div>
      <TabsProvider
        pregledTestiranja={pregledTestiranja}
        konverzacijeTestiranja={konverzacijeTestiranja}
        pregledLoading={pregledLoading}
        konverzacijeLoading={konverzacijeLoading}
        handleClickNapomena={handleClickNapomena}
        idMasineTest={idMasineTest}
      />
      <MuiDialog
        maxWidth="xl"
        open={openDialogNapomena}
        title="Napomena"
        content={
          <div>
            <div style={{ marginBottom: '10px', textDecoration: 'underline' }}>
              {napomena.zaposleni} {formatDateFromDB(napomena.datum)}
            </div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{napomena.napomena}</div>
          </div>
        }
        handleClose={() => setOpenDialogNapomena(false)}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Testiranje;
